// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___1VEr1","content":"styles__content___2tHj2","icon":"styles__icon___2pyM_","button":"styles__button___1ilxZ"};